import * as React from 'react';
import Modal from 'react-modal';
import { Button } from 'react-bootstrap';
import { translateService } from '../../services/TranslateService';
import { ResponseModalStruct } from '../../interfaces/ModalStructs';
import './ResponseModal.scss';
import { cStylesResponseModal } from '../../CustomModalStyles';
import { sanitizeHtml, validateRedirectUrl } from '../../services/securityUtils';

interface ResponseModalProps {
    response?: ResponseModalStruct;
    closeFunc: (redirect: string | undefined) => void;
}

const ResponseModal: React.FC<ResponseModalProps> = (props: any) => {
    const failedPaymentRedirect = sessionStorage.getItem('failCreateResRedirectUrl') ?? undefined;
    Modal.setAppElement('body');

    let responseclass = 'response-text';
    if (props.response && props.response.justify && props.response.justify === 'left') {
        responseclass = 'response-text response-text-left';
    }

    return (
        <Modal isOpen={!!props.response} style={cStylesResponseModal} contentLabel='Response Modal'>
            <div className={responseclass}>
                {props.response && props.response.html ?
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.response ? sanitizeHtml(props.response.html) : '',
                        }}
                    /> : props.response?.text ? props.response.text : props.response}

            </div>
            <div className='response-button'>
                {!failedPaymentRedirect ?
                    <Button
                        className='btn btn-all mt-3'
                        color='primary'
                        onClick={() => {
                            if(props.response.scrollToTop) {
                                setTimeout(() => {
                                    document.getElementById('check-available-times')?.scrollIntoView({
                                        behavior: 'smooth',block: 'center'})
                                }, 0);
                            }
                            props.closeFunc(props.response && props.response.redirect)}} >
                        {props.response
                            ? props.response.buttonText
                                ? props.response.buttonText
                                : translateService.translate('globalTexts.ok')
                            : undefined}
                    </Button>
                : <Button
                        className='btn btn-all mt-3'
                        color='primary'
                        onClick={() => {
                            sessionStorage.removeItem('failCreateResRedirectUrl');
                            let redirectLink = failedPaymentRedirect;
                            if (failedPaymentRedirect.startsWith('"') && failedPaymentRedirect.endsWith('"')) {
                                redirectLink = failedPaymentRedirect.slice(1, -1);
                            }
                            window.location.href = validateRedirectUrl(redirectLink)}} >
                        {translateService.translate('globalTexts.ok')}
                    </Button>}

            </div>

        </Modal>
    );
};
export default ResponseModal;
